<div class="root-container">
  <form 
  class="form-group" 
  [formGroup]="form">
    <div class="row">
      <div class="col-lg-4 col-md-6">
          <label for="fae_abbr" class="mb-2 required">FAE Abbreviation (used for quotation reference) </label>
          <input
            type="text"
            id="fae_abbr"
            name="fae_abbr"
            placeholder="(A-Z) (Underscore _ ) No Spaces "
            class="form-control"
            formControlName="fae_abbr"
            maxlength="51"
            required
          />

          <div class="error-label">
              <validation-error
                      [form]="form"
                      controlName="fae_abbr"
                      [validation]="{
                        required: 'FAE Abbreviation is required',
                        maxlength: 'FAE Abbreviation must be 50 characters or less',
                        pattern: 'Must be Uppercase. Digits and Special characters are not allowed'
                      }"
              />
          </div>

          <label for="category" class=" mb-2 label-title">
            Category
          </label>
          <div class="d-flex gap-3">
            <input
              type="radio"
              id="school"
              name="category"
              formControlName="category"
              value="academe"
            />
            <label for="school" class="ml-2">Academe</label>

            <input
              type="radio"
              id="industry"
              name="category"
              formControlName="category"
              value="industrial"
            />
            <label for="industry" class="ml-2">Industrial</label>
          </div>
          <div class="error-label">
            <validation-error
              [form]="form"
              controlName="category"
              [validation]="{
              required: 'Please select an option',
            }"
            />
          </div>
      </div>
      <div class="col-lg-4 col-md-6">
        <label 
        class="mb-2">E-Signature </label>
        @if (editing()) {
          <div
            [class.blur]="isProcessing()"
          >
            <image-picker
              [url]="image()"
              accepts='.jpg , .jpeg , .png'
              [max_size]="5242880"
              (fileUpload)="onFileChange($event)"
            >
              <div class="image-desc">(jpg jpeg png) (5MB)</div>
            </image-picker>
          </div>
        } @else {
          <div 
          class="d-flex justify-content-center"
          style="height: 200px;"
          >
            <img 
            style="height: 100%;"
            [src]="image() || 'assets/images/defaults/default_image.png'" 
            alt="default_image">
          </div>
        }
        <p style="font-size: 11px;">Note: Please use an image with black sign and white background. Uploaded E-Signature will be used in generated documents.
        </p>
      </div>
    </div>
  </form>
</div>
